<div class="card">
  <app-header
    titulo="Contratos cancelados"
    descricao="Contratos cancelados no PIMS e ERP"
  ></app-header>

  <app-contratos [habilitaIntegracao]="false" [habilitaCancelamento]="false" [habilitaBusca]="false" statusContrato="CA"></app-contratos>

</div>
